export const utilFormatPhoneNumber = (rawPhone: string): string => {
  const digits = rawPhone.replace(/\D/g, '');

  let normalized = digits;
  if (digits.startsWith('8')) {
    normalized = '7' + digits.slice(1);
  } else if (digits.startsWith('7')) {
    normalized = digits;
  } else if (digits.length === 10) {
    normalized = '7' + digits;
  }

  if (normalized.length !== 11 || !normalized.startsWith('7')) {
    return rawPhone;
  }

  const parts = normalized.match(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (!parts) {
    return rawPhone;
  }

  return `+7 (${parts[1]}) ${parts[2]} ${parts[3]} ${parts[4]}`;
};

export const getClearPhoneNumber = (phone: string) => {
  return phone.replace(/\D/g, '');
};

export const phoneMask = '+7 (999) 999-99-99';

export const phoneRegex =
  /^\+?\d{1,4}?\s?\(?\d{1,4}\)?[\s-]?\d{1,4}[\s-]?\d{1,4}[\s-]?\d{1,9}$/;
